/*
  example:
    import { getArchAttachment } from '@/services/Architectural/ArchitecturalSubmissionAttachment/GetAttachmentFile';

    const { successful, photo, message } = await getArchAttachment ({
      params: {
        architecturalSubmissionAttachmentID,
        asBase64: true
      }
    });
    if (!successful) {
      console.error (message);
      return;
    }
*/
//
import kms from '@/services/kms'
//
export async function getArchAttachment({ params }) {
  const message = 'The lease document could not be retrieved.'

  try {
    const photo = await kms.get(
      `/Architectural/ArchitecturalSubmissionAttachment/GetAttachmentFile`,
      {
        params
      }
    )

    return {
      successful: true,
      message: '',
      photo,
      id: params.architecturalSubmissionAttachmentID
    }
  } catch (exception) {
    console.error(exception)
  }

  return {
    successful: false,
    message,
    photo: null,
    id: null
  }
}

///////
